import hooks from '@/utils/hooks';
import { getLocalizedString } from './getLocalizedString';
import state from '@/state';

// Returns true if login was navigated to or handled by a hook
export default function () {
    let handled = hooks.run('requestLogin', {});
    if (handled) {
        return true;
    }
    const merchantConfigParam = state.merchantConfig.loginUrl || '';
    const loginUrl = getLocalizedString(merchantConfigParam);
    if (loginUrl) {
        window.location = loginUrl;
        return true;
    }

    return false;
}